import React from "react"
import { Link } from "react-router-dom"

const NavMobile = () => (
  <nav
    className="visible-xs mobile-menu-container mobile-effect"
    itemScope
    itemType="http://schema.org/SiteNavigationElement"
  >
    <div className="inner-off-canvas">
      <div className="menu-mobile-effect navbar-toggle">
        Fermer <i className="fa fa-times" />
      </div>
      <ul className="nav main-menu">
        <li className="menu-item">
          <Link to="/">Accueil</Link>
        </li>
        <li className="menu-item">
          <Link to="/about">A propos</Link>
        </li>
        <li className="menu-item">
          <Link to="/rooms">Chambres</Link>
        </li>
        <li className="menu-item">
          <Link to="/events">Evenements</Link>
        </li>
        <li className="menu-item">
          <Link to="/contact">Contact</Link>
        </li>
      </ul>
    </div>
  </nav>
);

export default NavMobile;
